<template>
    <FormularioCadastro :user="user" :me="me" @updated="updatedLegalPerson" :admin="false" />
</template>
<script>
import FormularioCadastro from '../components/FormularioCadastro.vue';
import api from '@/services'
export default {
    components: { FormularioCadastro },
    props: {
        user: Object,
    },
    data() {
        return {
            requestingApi: null,
            me: {},
        };
    },
    mounted() { },
    activated() {
        var vm = this
        vm.me = api.auth.user()
    },
    methods: {
        updatedLegalPerson(data) {
            var vm = this
            vm.loadUser()
        },
        loadUser() {
            var vm = this;
            vm.requestingApi = true;
            return new Promise((resolve, reject) => {
                api.auth
                    .me()
                    .then((result) => {
                        vm.me = result || {};
                        vm.$emit("loggedIn", result);
                    })
                    .catch((err) => {
                        if (err.message) {
                            vm.$notify({
                                type: "warn",
                                text: err.message,
                            });
                        }
                    })
                    .finally(() => {
                        vm.requestingApi = false;
                    });
            });
        }
    },
    watch: {}
};
</script>